/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Lot_Trace_Reason_Bridge_MissingInputs */

const vi_order_lot_trace_reason_bridge_missing = /** @type {(inputs: Order_Lot_Trace_Reason_Bridge_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thiếu liên kết trong bảng nguồn`)
};

/**

* @param {Order_Lot_Trace_Reason_Bridge_MissingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_lot_trace_reason_bridge_missing = /** @type {((inputs?: Order_Lot_Trace_Reason_Bridge_MissingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Lot_Trace_Reason_Bridge_MissingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_lot_trace_reason_bridge_missing(inputs)
});